import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CreatePatientComponent } from './create-patient.component';

@Component({
  selector: 'create-patient-routed',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CreatePatientRoutedComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this._openDialog();
  }

  _openDialog() {
    this.dialog
      .open(CreatePatientComponent, { minWidth: '1024px' })
      .afterClosed()
      .subscribe((routeArr = ['..']) =>
        this.router.navigate(routeArr, { relativeTo: this.route })
      );
  }
}
